import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { baseApiUrl, getDynamicData } from "../service/base-url";
import TabPanel from "../components/TabPanel";
import ShowProducts from "../components/ShowProducts";
import axios from "axios";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
// import { useTranslation } from "react-i18next";

const Works  = () => {
  const location = useLocation();
  const [categories, setCategories] = useState([])
  const [works, setWorks] = useState([])

  const language = useSelector((state) => state.language.language);
  // const { t } = useTranslation(); // Hook for translations
    // const [selectedCategory, setSelectedCategory] = useState(6);

    useEffect(() => {
        const storedCategory = sessionStorage.getItem("selectedCategory");
        const categoryId = storedCategory ? parseInt(storedCategory, 10) : location?.state?.item.id ?? 6;
        // setSelectedCategory(categoryId); // 🔥 Store it in state
        // setCurrentPage(1);  // Reset pagination
        setWorks([]);       // Clear previous works before fetching new ones
        sortWorks(categoryId);
    }, [language, location?.state?.item.id]);  // Ensure it runs when language changes



  useEffect(() => {
    getDynamicData('categories/parents', setCategories, null, language)
  }, [language])

  const sortWorks = async (category_id) => {
    try {
        // setSelectedCategory(category_id);
        sessionStorage.setItem("selectedCategory", category_id);

        setWorks([]);  // Ensure we clear previous data before fetching new data
        // setLinks(null);
      const url =  `${baseApiUrl}/categories/${category_id}/children`;

      const response = await axios.get(url, {
        headers: { 'Content-Type': 'application/json', 'x-localization': language, },
      });

      const dataRes = response.data;
      if (dataRes) {
        setWorks(dataRes.data);
        // setLinks(dataRes.links);
      }
    } catch (error) {
      toast.error('Please try again.');
      console.error('Error:', error);
    }
  };


  

  return (
    <div className="px-5 xl:px-20">
      <TabPanel id={location?.state?.item.id} sortWorks={sortWorks} categories={categories} />
      <ShowProducts works={works} />
    
    </div>
  )
}

export default Works
